/* eslint-disable no-undef */
/* eslint-disable func-names */
import Vue from 'vue';
import VueRouter from 'vue-router';
import storage from 'localforage';

import CheckoutRouter from '@/feature/checkout/checkout.router';
import PreQualifyRouter from '@/feature/prequalify/preQualify.router';
import OnboardingRouter from '@/feature/onboarding/onboarding.router';
import RetargetingRouter from '@/feature/retargeting/retargeting.router';
import LoginRouter from '@/feature/login/login.router';
import TenantRoutes from '@/feature/tenant/tenant.routes';
import guarantorRoutes from '@/feature/guarantor/guarantor.routes';
import paymentLinkRouter from '@/feature/paymentLink/paymentLink.router';
import onboardingV2Router from '@/feature/onboarding-v2/onboardingV2.router';
import onboardingMinifiedRouter from '@/feature/minified-onboarding/minified-onboarding.router';
import installmentsRouter from '@/feature/installments/installments.router';
import globals from '@/globals';

Vue.use(VueRouter);

const routes = [
  CheckoutRouter,
  ...PreQualifyRouter,
  ...OnboardingRouter,
  RetargetingRouter,
  ...LoginRouter.routes,
  ...TenantRoutes,
  guarantorRoutes,
  ...paymentLinkRouter,
  ...onboardingV2Router,
  ...onboardingMinifiedRouter,
  installmentsRouter,
  {
    path: '*',
    name: 'not-found',
    component: () => import('./views/NotFound.vue'),
  },
  {
    path: '/',
    redirect: '/login',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

const gtagEvents = {
  conversion: {
    send_to: 'AW-516708123/fnTECLXIt_wBEJuusfYB',
    paths: [
      '/login/verificacao/aprovada',
      '/simulacao/:context/aprovado',
      '/checkout/:context/aprovado',
    ],
  },
};

function isValidPath({ path, paths }) {
  let isValid = false;

  for (let i = 0; i < paths.length; i += 1) {
    const currPath = paths[i];

    if (currPath.includes('/:')) {
      const splitedPath = currPath.split('/:');
      const beforeParam = splitedPath[0];
      const afterParam = `/${splitedPath.pop().split('/').pop()}`;

      if (path.startsWith(beforeParam) && path.endsWith(afterParam)) {
        isValid = true;
        break;
      }
    } else if (currPath === path) {
      isValid = true;
      break;
    }
  }

  return isValid;
}

function handleGtagEvents({ path }) {
  if (globals().nodeEnv !== 'production') return;

  Object.keys(gtagEvents).forEach((key) => {
    if (isValidPath({ path, paths: gtagEvents[key].paths })) {
      gtag('event', key, { send_to: gtagEvents[key].send_to });
    }
  });
}

router.afterEach((to) => {
  gtag('config', window.GA_TRACKING_ID, {
    page_path: to.fullPath,
    send_page_view: true,
  });

  handleGtagEvents({ path: to.path });
});

function patchRouterMethod(routerInstance, methodName) {
  // eslint-disable-next-line no-param-reassign
  routerInstance[`old${methodName}`] = routerInstance[methodName];
  // eslint-disable-next-line no-param-reassign
  routerInstance[methodName] = async function (location) {
    return router[`old${methodName}`](location).catch((error) => {
      if (error.name === 'NavigationDuplicated') {
        return this.currentRoute;
      }
      throw error;
    });
  };
}

patchRouterMethod(router, 'push');
patchRouterMethod(router, 'replace');

const { nodeEnv } = globals();
const baseURL = nodeEnv === 'homolog'
  ? 'https://portal-homolog.parcelex.com.br'
  : 'https://portal.parcelex.com.br';

router.beforeEach(async (to, from, next) => {
  if (to.path.includes('/portal')) {
    const {
      auth: { token },
    } = await storage.getItem('vuex');
    window.location.href = `${baseURL}/home${token ? `?authToken=${token}` : ''}`;
  } else if (to.path.includes('/login')) {
    window.location.href = baseURL;
  } else {
    const featureRoute = to.path.split('/').filter((el) => el)[0];
    switch (featureRoute) {
      case 'login':
        LoginRouter.beforeEachRoute(to, from, next);
        break;
      default:
        setTimeout(() => next(), 10);
    }
  }
});

export default router;
